(function (_, $module$uuid, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var v4 = $module$uuid.v4;
  var protoOf = kotlin_kotlin.$_$.j1;
  var initMetadataForInterface = kotlin_kotlin.$_$.a1;
  var VOID = kotlin_kotlin.$_$.b;
  var Unit_instance = kotlin_kotlin.$_$.f;
  var initMetadataForObject = kotlin_kotlin.$_$.b1;
  var defineProp = kotlin_kotlin.$_$.t;
  var to = kotlin_kotlin.$_$.w1;
  var mapOf = kotlin_kotlin.$_$.o;
  var plus = kotlin_kotlin.$_$.p;
  var emptyMap = kotlin_kotlin.$_$.k;
  var getKClassFromExpression = kotlin_kotlin.$_$.a;
  var toString = kotlin_kotlin.$_$.l1;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.e;
  var initMetadataForClass = kotlin_kotlin.$_$.y;
  var numberToLong = kotlin_kotlin.$_$.h1;
  var toMap = kotlin_kotlin.$_$.r;
  var asSequence = kotlin_kotlin.$_$.j;
  var flatMap = kotlin_kotlin.$_$.n1;
  var toString_0 = kotlin_kotlin.$_$.v1;
  var sequenceOf = kotlin_kotlin.$_$.p1;
  var Iterable = kotlin_kotlin.$_$.g;
  var isInterface = kotlin_kotlin.$_$.e1;
  var isNumber = kotlin_kotlin.$_$.f1;
  var isCharSequence = kotlin_kotlin.$_$.d1;
  var KtMap = kotlin_kotlin.$_$.h;
  var map = kotlin_kotlin.$_$.o1;
  var StringBuilder = kotlin_kotlin.$_$.q1;
  var KtMutableMap = kotlin_kotlin.$_$.i;
  var objectCreate = kotlin_kotlin.$_$.i1;
  var Long = kotlin_kotlin.$_$.s1;
  var toLong = kotlin_kotlin.$_$.k1;
  var initMetadataForCompanion = kotlin_kotlin.$_$.z;
  var getStringHashCode = kotlin_kotlin.$_$.x;
  var getNumberHashCode = kotlin_kotlin.$_$.w;
  var getBooleanHashCode = kotlin_kotlin.$_$.v;
  var THROW_CCE = kotlin_kotlin.$_$.t1;
  var equals = kotlin_kotlin.$_$.u;
  var compareTo = kotlin_kotlin.$_$.s;
  var THROW_IAE = kotlin_kotlin.$_$.u1;
  var Enum = kotlin_kotlin.$_$.r1;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.d;
  var numberToDouble = kotlin_kotlin.$_$.g1;
  var isArray = kotlin_kotlin.$_$.c1;
  var toList = kotlin_kotlin.$_$.q;
  var mapCapacity = kotlin_kotlin.$_$.m;
  var coerceAtLeast = kotlin_kotlin.$_$.m1;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.c;
  //endregion
  //region block: pre-declaration
  function onSessionUpdated(session) {
  }
  function onRestoreSession() {
    return null;
  }
  initMetadataForInterface(DynamicSessionDelegate, 'DynamicSessionDelegate');
  function onUserIdentified(userId) {
  }
  function sendMetric(track, tags) {
  }
  initMetadataForInterface(AnalyticsDelegate, 'AnalyticsDelegate', VOID, VOID, [DynamicSessionDelegate]);
  initMetadataForInterface(DynamicSessionService, 'DynamicSessionService');
  function trackWithoutContext(track) {
    return this.track(track, null);
  }
  function identifyCurrentLocation(latitude, longitude, accuracy, timestamp) {
    var tmp0 = this.globalData;
    var tmp1 = 'currentLocationLatitude';
    // Inline function 'kotlin.collections.set' call
    var value = latitude == null ? null : latitude.toString();
    tmp0.y(tmp1, value);
    var tmp3 = this.globalData;
    var tmp4 = 'currentLocationLongitude';
    // Inline function 'kotlin.collections.set' call
    var value_0 = longitude == null ? null : longitude.toString();
    tmp3.y(tmp4, value_0);
    var tmp6 = this.globalData;
    var tmp7 = 'currentLocationAccuracy';
    // Inline function 'kotlin.collections.set' call
    var value_1 = accuracy == null ? null : accuracy.toString();
    tmp6.y(tmp7, value_1);
    var tmp9 = this.globalData;
    var tmp10 = 'currentLocationTimestamp';
    // Inline function 'kotlin.collections.set' call
    var value_2 = timestamp == null ? null : timestamp.toString();
    tmp9.y(tmp10, value_2);
  }
  function identifyDeliveryLocation(city, country, latitude, longitude, accuracy, timestamp) {
    // Inline function 'kotlin.collections.set' call
    this.globalData.y('city', city);
    // Inline function 'kotlin.collections.set' call
    this.globalData.y('country', country);
    var tmp6 = this.globalData;
    var tmp7 = 'deliveryLocationLatitude';
    // Inline function 'kotlin.collections.set' call
    var value = latitude == null ? null : latitude.toString();
    tmp6.y(tmp7, value);
    var tmp9 = this.globalData;
    var tmp10 = 'deliveryLocationLongitude';
    // Inline function 'kotlin.collections.set' call
    var value_0 = longitude == null ? null : longitude.toString();
    tmp9.y(tmp10, value_0);
    var tmp12 = this.globalData;
    var tmp13 = 'deliveryLocationAccuracy';
    // Inline function 'kotlin.collections.set' call
    var value_1 = accuracy == null ? null : accuracy.toString();
    tmp12.y(tmp13, value_1);
    var tmp15 = this.globalData;
    var tmp16 = 'deliveryLocationTimestamp';
    // Inline function 'kotlin.collections.set' call
    var value_2 = timestamp == null ? null : timestamp.toString();
    tmp15.y(tmp16, value_2);
  }
  function identifyPerseusIds(perseusClientId, perseusSessionId) {
    var tmp0 = this.globalData;
    // Inline function 'kotlin.collections.set' call
    var key = 'perseusSessionId';
    tmp0.y(key, perseusSessionId);
    var tmp3 = this.globalData;
    // Inline function 'kotlin.collections.set' call
    var key_0 = 'perseusClientId';
    tmp3.y(key_0, perseusClientId);
  }
  initMetadataForInterface(AnalyticsService, 'AnalyticsService', VOID, VOID, [DynamicSessionService]);
  initMetadataForObject(AnalyticsServiceFactory, 'AnalyticsServiceFactory');
  initMetadataForClass(AnalyticsServiceImpl, 'AnalyticsServiceImpl', VOID, VOID, [AnalyticsService, DynamicSessionService]);
  initMetadataForClass(NonNullMap, 'NonNullMap', NonNullMap, VOID, [KtMutableMap]);
  initMetadataForCompanion(Companion);
  initMetadataForClass(DynamicSession, 'DynamicSession');
  initMetadataForClass(DynamicSessionServiceImpl, 'DynamicSessionServiceImpl', VOID, VOID, [DynamicSessionService]);
  initMetadataForClass(Action, 'Action', VOID, Enum);
  initMetadataForClass(Product, 'Product');
  initMetadataForInterface(Track, 'Track');
  initMetadataForClass(Event, 'Event', VOID, VOID, [Track]);
  initMetadataForClass(Impression, 'Impression', VOID, VOID, [Track]);
  initMetadataForObject(ECommerce, 'ECommerce');
  initMetadataForClass(Event_0, 'Event', VOID, VOID, [Track]);
  initMetadataForClass(EventType, 'EventType', VOID, Enum);
  initMetadataForClass(Screen, 'Screen', VOID, VOID, [Track]);
  initMetadataForClass(AtomicRef, 'AtomicRef');
  //endregion
  function AnalyticsDelegate() {
  }
  function AnalyticsService() {
  }
  function AnalyticsServiceFactory() {
  }
  protoOf(AnalyticsServiceFactory).create = function (delegate, appVersion) {
    return new AnalyticsServiceImpl(delegate, appVersion);
  };
  var AnalyticsServiceFactory_instance;
  function AnalyticsServiceFactory_getInstance() {
    return AnalyticsServiceFactory_instance;
  }
  function metricTags($this, _this__u8e3s4, succeed) {
    var tmp = to('eventName', _this__u8e3s4.name);
    var tmp_0 = to('eventType', _get_metricType__axossh($this, _this__u8e3s4));
    var tmp0_elvis_lhs = _this__u8e3s4.owner;
    return get_nativePlatformValue(plus($this.a9_1, mapOf([tmp, tmp_0, to('owner', tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs), to('result', succeed ? 'succeed' : 'error')])));
  }
  function _get_metricType__axossh($this, _this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof Event_0) {
      tmp = 'event';
    } else {
      if (_this__u8e3s4 instanceof Screen) {
        tmp = 'screen';
      } else {
        if (_this__u8e3s4 instanceof Event) {
          tmp = 'eCommerce:event';
        } else {
          if (_this__u8e3s4 instanceof Impression) {
            tmp = 'eCommerce:impression';
          } else {
            tmp = '<unknown>';
          }
        }
      }
    }
    return tmp;
  }
  function AnalyticsServiceImpl$$$delegate_0$lambda($globalData) {
    return function (it) {
      var tmp0 = $globalData;
      var tmp1 = 'dynamicSessionId';
      // Inline function 'kotlin.collections.set' call
      var value = it.dynamicSessionId;
      tmp0.y(tmp1, value);
      return Unit_instance;
    };
  }
  function AnalyticsServiceImpl(delegate, appVersion, globalData) {
    appVersion = appVersion === VOID ? null : appVersion;
    globalData = globalData === VOID ? new NonNullMap() : globalData;
    var tmp = this;
    tmp.x8_1 = new DynamicSessionServiceImpl(delegate, AnalyticsServiceImpl$$$delegate_0$lambda(globalData));
    this.y8_1 = delegate;
    this.z8_1 = globalData;
    this.a9_1 = mapOf([to('appVersion', appVersion), to('multiplatformVersion', '2.4.0'), to('platform', get_PLATFORM())]);
    var tmp0 = this.z8_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map = this.a9_1;
    tmp0.a1(map);
  }
  protoOf(AnalyticsServiceImpl).w8 = function () {
    return this.z8_1;
  };
  protoOf(AnalyticsServiceImpl).identifyUser = function (userId) {
    this.y8_1.onUserIdentified(userId);
    var tmp0 = this.z8_1;
    var tmp1 = 'isAuthorized';
    // Inline function 'kotlin.collections.set' call
    var value = (!(userId == null)).toString();
    tmp0.y(tmp1, value);
  };
  protoOf(AnalyticsServiceImpl).identifyDevice = function (urn) {
    var tmp0 = this.z8_1;
    // Inline function 'kotlin.collections.set' call
    var key = 'deviceUrn';
    tmp0.y(key, urn);
  };
  protoOf(AnalyticsServiceImpl).track = function (track, context) {
    var tmp;
    try {
      this.onSessionResumed();
      var tmp0_safe_receiver = track.globalData;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.collections.plusAssign' call
        this.z8_1.a1(tmp0_safe_receiver);
      }
      var tmp1_elvis_lhs = track.data;
      var data = get_nativePlatformValue(plus(tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs, this.z8_1));
      if (track instanceof Event_0) {
        this.y8_1.event(track.name, data, track.type, context);
      } else {
        if (track instanceof Screen) {
          this.y8_1.screen(track.name, data, context);
          this.y8_1.event('Viewed ' + track.name + ' Screen', data, EventType_Navigation_getInstance(), context);
        } else {
          if (track instanceof Event) {
            this.y8_1.eCommerceEvent(track.action, get_nativePlatformValue_0(track.products), track.affiliation, data, context);
          } else {
            if (track instanceof Impression) {
              this.y8_1.eCommerceImpression(track.listName, get_nativePlatformValue_0(track.products), data, context);
            } else {
              // Inline function 'kotlin.error' call
              var message = 'Unknown track type ' + toString(getKClassFromExpression(track));
              throw IllegalStateException_init_$Create$(toString(message));
            }
          }
        }
      }
      this.y8_1.sendMetric(track, metricTags(this, track, true));
      tmp = Unit_instance;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var error = $p;
        this.y8_1.sendMetric(track, metricTags(this, track, false));
        throw error;
      } else {
        throw $p;
      }
    }
    return tmp;
  };
  protoOf(AnalyticsServiceImpl).onSessionResumed = function () {
    return this.x8_1.onSessionResumed();
  };
  function plus_0(_this__u8e3s4, other) {
    return get_timestamp(numberToLong(_this__u8e3s4).p1(numberToLong(other)));
  }
  function minus(_this__u8e3s4, other) {
    return get_timestamp(numberToLong(_this__u8e3s4).q1(numberToLong(other)));
  }
  function get_value(_this__u8e3s4) {
    return toString(_this__u8e3s4);
  }
  function get_value_0(_this__u8e3s4) {
    return _this__u8e3s4.toString();
  }
  function get_value_1(_this__u8e3s4) {
    return toString(_this__u8e3s4);
  }
  function get_value_2(_this__u8e3s4) {
    return get_mParticleLimitedValue(get_commonPlatformValue(_this__u8e3s4));
  }
  function get_data(_this__u8e3s4) {
    return toMap(propertiesData(get_commonPlatformValue_0(_this__u8e3s4), ''));
  }
  function propertiesData(_this__u8e3s4, suffix) {
    var tmp = asSequence(_this__u8e3s4.x());
    return flatMap(tmp, propertiesData$lambda(suffix));
  }
  function propertiesData$lambda($suffix) {
    return function (_destruct__k2r9zo) {
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.q();
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.r();
      var flatKey = $suffix + toString_0(key);
      var tmp;
      if (!(value == null) ? isInterface(value, KtMap) : false) {
        tmp = propertiesData(value, flatKey + '.');
      } else {
        if (!(value == null) ? isCharSequence(value) : false) {
          tmp = sequenceOf([to(flatKey, get_value(value))]);
        } else {
          if (!(value == null) ? typeof value === 'boolean' : false) {
            tmp = sequenceOf([to(flatKey, get_value_0(value))]);
          } else {
            if (isNumber(value)) {
              tmp = sequenceOf([to(flatKey, get_value_1(value))]);
            } else {
              if (!(value == null) ? isInterface(value, Iterable) : false) {
                tmp = sequenceOf([to(flatKey, get_value_2(value))]);
              } else {
                tmp = sequenceOf([to(flatKey, value == null ? null : toString(value))]);
              }
            }
          }
        }
      }
      return tmp;
    };
  }
  function get_mParticleLimitedValue(_this__u8e3s4) {
    var tmp = asSequence(_this__u8e3s4);
    return mParticleLimitedValue(map(tmp, _get_mParticleLimitedValue_$lambda_xg3cf8).c());
  }
  function mParticleLimitedValue(_this__u8e3s4, capacity) {
    capacity = capacity === VOID ? 4096 : capacity;
    var buffer = new StringBuilder('[');
    var separator = false;
    var remaining = capacity - 2 | 0;
    $l$loop: while (remaining > 1 && _this__u8e3s4.d()) {
      var next = _this__u8e3s4.e();
      if (remaining > next.length) {
        if (separator) {
          buffer.f6(',');
          remaining = remaining - 1 | 0;
        }
        buffer.f6(next);
        remaining = remaining - next.length | 0;
        separator = true;
      } else {
        break $l$loop;
      }
    }
    buffer.f6(']');
    return buffer.toString();
  }
  function _get_mParticleLimitedValue_$lambda_xg3cf8(it) {
    return toString_0(it);
  }
  function NonNullMap(map) {
    map = map === VOID ? threadSafeMutableMap() : map;
    this.n9_1 = map;
  }
  protoOf(NonNullMap).y = function (key, value) {
    return value == null ? this.z(key) : this.n9_1.y(key, value);
  };
  protoOf(NonNullMap).a1 = function (from) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = from.x().c();
    while (_iterator__ex2g4s.d()) {
      var element = _iterator__ex2g4s.e();
      // Inline function 'kotlin.collections.component1' call
      var key = element.q();
      // Inline function 'kotlin.collections.component2' call
      var value = element.r();
      this.y(key, value);
    }
    return Unit_instance;
  };
  protoOf(NonNullMap).z = function (key) {
    return this.n9_1.z(key);
  };
  protoOf(NonNullMap).b1 = function () {
    this.n9_1.b1();
  };
  protoOf(NonNullMap).asJsMapView = function () {
    return this.n9_1.asJsMapView();
  };
  protoOf(NonNullMap).v = function () {
    return this.n9_1.v();
  };
  protoOf(NonNullMap).w = function () {
    return this.n9_1.w();
  };
  protoOf(NonNullMap).x = function () {
    return this.n9_1.x();
  };
  protoOf(NonNullMap).h = function () {
    return this.n9_1.h();
  };
  protoOf(NonNullMap).s = function (key) {
    return this.n9_1.s(key);
  };
  protoOf(NonNullMap).t = function (value) {
    return this.n9_1.t(value);
  };
  protoOf(NonNullMap).u = function (key) {
    return this.n9_1.u(key);
  };
  protoOf(NonNullMap).asJsReadonlyMapView = function () {
    return this.n9_1.asJsReadonlyMapView();
  };
  protoOf(NonNullMap).g = function () {
    return this.n9_1.g();
  };
  function DynamicSession_init_$Init$(dynamicSessionId, createdAt, $this) {
    DynamicSession.call($this, dynamicSessionId, createdAt, createdAt);
    return $this;
  }
  function create(dynamicSessionId, createdAt) {
    return DynamicSession_init_$Init$(dynamicSessionId, createdAt, objectCreate(protoOf(DynamicSession)));
  }
  function Companion() {
    Companion_instance = this;
    var tmp = this;
    // Inline function 'kotlin.Long.times' call
    // Inline function 'kotlin.Long.times' call
    var tmp$ret$1 = (new Long(1000, 0)).r1(toLong(60)).r1(toLong(60));
    tmp.expirationThreshold = get_timestamp(tmp$ret$1);
  }
  protoOf(Companion).o9 = function () {
    return this.expirationThreshold;
  };
  var Companion_instance;
  function Companion_getInstance() {
    if (Companion_instance == null)
      new Companion();
    return Companion_instance;
  }
  function DynamicSession(dynamicSessionId, createdAt, lastActivityTime, lastInactivityPeriod, isNew) {
    Companion_getInstance();
    lastActivityTime = lastActivityTime === VOID ? createdAt : lastActivityTime;
    lastInactivityPeriod = lastInactivityPeriod === VOID ? null : lastInactivityPeriod;
    isNew = isNew === VOID ? false : isNew;
    this.dynamicSessionId = dynamicSessionId;
    this.createdAt = createdAt;
    this.lastActivityTime = lastActivityTime;
    this.lastInactivityPeriod = lastInactivityPeriod;
    this.isNew = isNew;
    this.expiresAt = plus_0(this.lastActivityTime, Companion_getInstance().expirationThreshold);
  }
  protoOf(DynamicSession).p9 = function () {
    return this.dynamicSessionId;
  };
  protoOf(DynamicSession).q9 = function () {
    return this.createdAt;
  };
  protoOf(DynamicSession).r9 = function () {
    return this.lastActivityTime;
  };
  protoOf(DynamicSession).s9 = function () {
    return this.lastInactivityPeriod;
  };
  protoOf(DynamicSession).t9 = function () {
    return this.isNew;
  };
  protoOf(DynamicSession).u9 = function () {
    return this.expiresAt;
  };
  protoOf(DynamicSession).h8 = function () {
    return this.dynamicSessionId;
  };
  protoOf(DynamicSession).i8 = function () {
    return this.createdAt;
  };
  protoOf(DynamicSession).v9 = function () {
    return this.lastActivityTime;
  };
  protoOf(DynamicSession).w9 = function () {
    return this.lastInactivityPeriod;
  };
  protoOf(DynamicSession).x9 = function () {
    return this.isNew;
  };
  protoOf(DynamicSession).y9 = function (dynamicSessionId, createdAt, lastActivityTime, lastInactivityPeriod, isNew) {
    return new DynamicSession(dynamicSessionId, createdAt, lastActivityTime, lastInactivityPeriod, isNew);
  };
  protoOf(DynamicSession).copy = function (dynamicSessionId, createdAt, lastActivityTime, lastInactivityPeriod, isNew, $super) {
    dynamicSessionId = dynamicSessionId === VOID ? this.dynamicSessionId : dynamicSessionId;
    createdAt = createdAt === VOID ? this.createdAt : createdAt;
    lastActivityTime = lastActivityTime === VOID ? this.lastActivityTime : lastActivityTime;
    lastInactivityPeriod = lastInactivityPeriod === VOID ? this.lastInactivityPeriod : lastInactivityPeriod;
    isNew = isNew === VOID ? this.isNew : isNew;
    return $super === VOID ? this.y9(dynamicSessionId, createdAt, lastActivityTime, lastInactivityPeriod, isNew) : $super.y9.call(this, dynamicSessionId, createdAt, lastActivityTime, lastInactivityPeriod, isNew);
  };
  protoOf(DynamicSession).toString = function () {
    return 'DynamicSession(dynamicSessionId=' + this.dynamicSessionId + ', createdAt=' + this.createdAt + ', lastActivityTime=' + this.lastActivityTime + ', lastInactivityPeriod=' + this.lastInactivityPeriod + ', isNew=' + this.isNew + ')';
  };
  protoOf(DynamicSession).hashCode = function () {
    var result = getStringHashCode(this.dynamicSessionId);
    result = imul(result, 31) + getNumberHashCode(this.createdAt) | 0;
    result = imul(result, 31) + getNumberHashCode(this.lastActivityTime) | 0;
    result = imul(result, 31) + (this.lastInactivityPeriod == null ? 0 : getNumberHashCode(this.lastInactivityPeriod)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.isNew) | 0;
    return result;
  };
  protoOf(DynamicSession).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DynamicSession))
      return false;
    var tmp0_other_with_cast = other instanceof DynamicSession ? other : THROW_CCE();
    if (!(this.dynamicSessionId === tmp0_other_with_cast.dynamicSessionId))
      return false;
    if (!equals(this.createdAt, tmp0_other_with_cast.createdAt))
      return false;
    if (!equals(this.lastActivityTime, tmp0_other_with_cast.lastActivityTime))
      return false;
    if (!equals(this.lastInactivityPeriod, tmp0_other_with_cast.lastInactivityPeriod))
      return false;
    if (!(this.isNew === tmp0_other_with_cast.isNew))
      return false;
    return true;
  };
  function DynamicSessionDelegate() {
  }
  function DynamicSessionService() {
  }
  function _get_updatedOrNew__trhcjt($this, _this__u8e3s4) {
    var now = $this.ba_1();
    var tmp;
    if (_this__u8e3s4 == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeUnless' call
      var tmp_0;
      if (!(compareTo(now, _this__u8e3s4.expiresAt) >= 0)) {
        tmp_0 = _this__u8e3s4;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.copy(VOID, VOID, now, VOID, false);
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      var tmp5_dynamicSessionId = newUUID();
      var tmp4_safe_receiver = _this__u8e3s4 == null ? null : _this__u8e3s4.lastActivityTime;
      var tmp_2;
      if (tmp4_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = minus(now, tmp4_safe_receiver);
      }
      var tmp6_lastInactivityPeriod = tmp_2;
      tmp_1 = new DynamicSession(tmp5_dynamicSessionId, now, now, tmp6_lastInactivityPeriod, true);
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    return tmp_1;
  }
  function DynamicSessionServiceImpl$_init_$lambda_d0nzhp(it) {
    return Unit_instance;
  }
  function DynamicSessionServiceImpl$_init_$lambda_d0nzhp_0() {
    return get_currentTimeMillis();
  }
  function DynamicSessionServiceImpl(delegate, onSessionUpdated, currentTimeMillisProvider) {
    var tmp;
    if (onSessionUpdated === VOID) {
      tmp = DynamicSessionServiceImpl$_init_$lambda_d0nzhp;
    } else {
      tmp = onSessionUpdated;
    }
    onSessionUpdated = tmp;
    var tmp_0;
    if (currentTimeMillisProvider === VOID) {
      tmp_0 = DynamicSessionServiceImpl$_init_$lambda_d0nzhp_0;
    } else {
      tmp_0 = currentTimeMillisProvider;
    }
    currentTimeMillisProvider = tmp_0;
    this.z9_1 = delegate;
    this.aa_1 = onSessionUpdated;
    this.ba_1 = currentTimeMillisProvider;
    this.ca_1 = new Object();
    this.da_1 = atomicRef(null);
  }
  protoOf(DynamicSessionServiceImpl).onSessionResumed = function () {
    // Inline function 'com.glovoapp.analytics.synchronized' call
    this.ca_1;
    var tmp0_elvis_lhs = this.da_1.ea_1;
    // Inline function 'kotlin.also' call
    var this_0 = _get_updatedOrNew__trhcjt(this, tmp0_elvis_lhs == null ? this.z9_1.onRestoreSession() : tmp0_elvis_lhs);
    this.da_1.ea_1 = this_0;
    // Inline function 'kotlin.also' call
    this.aa_1(this_0);
    // Inline function 'kotlin.also' call
    this.z9_1.onSessionUpdated(this_0);
    return this_0;
  };
  var Action_AddToCart_instance;
  var Action_RemoveFromCart_instance;
  var Action_ViewDetail_instance;
  function values() {
    return [Action_AddToCart_getInstance(), Action_RemoveFromCart_getInstance(), Action_ViewDetail_getInstance()];
  }
  function valueOf(value) {
    switch (value) {
      case 'AddToCart':
        return Action_AddToCart_getInstance();
      case 'RemoveFromCart':
        return Action_RemoveFromCart_getInstance();
      case 'ViewDetail':
        return Action_ViewDetail_getInstance();
      default:
        Action_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var Action_entriesInitialized;
  function Action_initEntries() {
    if (Action_entriesInitialized)
      return Unit_instance;
    Action_entriesInitialized = true;
    Action_AddToCart_instance = new Action('AddToCart', 0, 'add_to_cart');
    Action_RemoveFromCart_instance = new Action('RemoveFromCart', 1, 'remove_from_cart');
    Action_ViewDetail_instance = new Action('ViewDetail', 2, 'view_detail');
  }
  function Action(name, ordinal, value) {
    Enum.call(this, name, ordinal);
    this.value = value;
  }
  protoOf(Action).r = function () {
    return this.value;
  };
  function Product(sku, name, quantity, price, couponCode) {
    quantity = quantity === VOID ? 1 : quantity;
    price = price === VOID ? null : price;
    couponCode = couponCode === VOID ? null : couponCode;
    this.sku = sku;
    this.name = name;
    this.quantity = quantity;
    this.price = price;
    this.couponCode = couponCode;
  }
  protoOf(Product).ha = function () {
    return this.sku;
  };
  protoOf(Product).e1 = function () {
    return this.name;
  };
  protoOf(Product).ia = function () {
    return this.quantity;
  };
  protoOf(Product).ja = function () {
    return this.price;
  };
  protoOf(Product).ka = function () {
    return this.couponCode;
  };
  protoOf(Product).h8 = function () {
    return this.sku;
  };
  protoOf(Product).i8 = function () {
    return this.name;
  };
  protoOf(Product).v9 = function () {
    return this.quantity;
  };
  protoOf(Product).w9 = function () {
    return this.price;
  };
  protoOf(Product).x9 = function () {
    return this.couponCode;
  };
  protoOf(Product).la = function (sku, name, quantity, price, couponCode) {
    return new Product(sku, name, quantity, price, couponCode);
  };
  protoOf(Product).copy = function (sku, name, quantity, price, couponCode, $super) {
    sku = sku === VOID ? this.sku : sku;
    name = name === VOID ? this.name : name;
    quantity = quantity === VOID ? this.quantity : quantity;
    price = price === VOID ? this.price : price;
    couponCode = couponCode === VOID ? this.couponCode : couponCode;
    return $super === VOID ? this.la(sku, name, quantity, price, couponCode) : $super.la.call(this, sku, name, quantity, price, couponCode);
  };
  protoOf(Product).toString = function () {
    return 'Product(sku=' + this.sku + ', name=' + this.name + ', quantity=' + this.quantity + ', price=' + this.price + ', couponCode=' + this.couponCode + ')';
  };
  protoOf(Product).hashCode = function () {
    var result = getStringHashCode(this.sku);
    result = imul(result, 31) + getStringHashCode(this.name) | 0;
    result = imul(result, 31) + this.quantity | 0;
    result = imul(result, 31) + (this.price == null ? 0 : getNumberHashCode(this.price)) | 0;
    result = imul(result, 31) + (this.couponCode == null ? 0 : getStringHashCode(this.couponCode)) | 0;
    return result;
  };
  protoOf(Product).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Product))
      return false;
    var tmp0_other_with_cast = other instanceof Product ? other : THROW_CCE();
    if (!(this.sku === tmp0_other_with_cast.sku))
      return false;
    if (!(this.name === tmp0_other_with_cast.name))
      return false;
    if (!(this.quantity === tmp0_other_with_cast.quantity))
      return false;
    if (!equals(this.price, tmp0_other_with_cast.price))
      return false;
    if (!(this.couponCode == tmp0_other_with_cast.couponCode))
      return false;
    return true;
  };
  function Event(action, products, affiliation, owner, data, globalData) {
    affiliation = affiliation === VOID ? null : affiliation;
    owner = owner === VOID ? null : owner;
    data = data === VOID ? null : data;
    globalData = globalData === VOID ? null : globalData;
    this.action = action;
    this.products = products;
    this.affiliation = affiliation;
    this.f9_1 = owner;
    this.g9_1 = data;
    this.h9_1 = globalData;
    this.i9_1 = this.action.value;
  }
  protoOf(Event).ma = function () {
    return this.action;
  };
  protoOf(Event).na = function () {
    return this.products;
  };
  protoOf(Event).oa = function () {
    return this.affiliation;
  };
  protoOf(Event).pa = function () {
    return this.f9_1;
  };
  protoOf(Event).qa = function () {
    return this.g9_1;
  };
  protoOf(Event).w8 = function () {
    return this.h9_1;
  };
  protoOf(Event).e1 = function () {
    return this.i9_1;
  };
  protoOf(Event).hashCode = function () {
    return this.action.hashCode();
  };
  protoOf(Event).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    var tmp_4;
    if (other instanceof Event) {
      tmp_4 = this.action.equals(other.action);
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = equals(this.products, other.products);
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.affiliation == other.affiliation;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.owner == other.owner;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(this.data, other.data);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.globalData, other.globalData);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Event).toString = function () {
    return "ECommerce.Event(action='" + this.action.toString() + "', products=" + toString(this.products) + ', affiliation=' + this.affiliation + ", owner='" + this.owner + "', data=" + toString_0(this.data) + ', globalData=' + toString_0(this.globalData) + ')';
  };
  function Impression(listName, products, owner, data, globalData) {
    owner = owner === VOID ? null : owner;
    data = data === VOID ? null : data;
    globalData = globalData === VOID ? null : globalData;
    this.listName = listName;
    this.products = products;
    this.b9_1 = owner;
    this.c9_1 = data;
    this.d9_1 = globalData;
    this.e9_1 = this.listName;
  }
  protoOf(Impression).ra = function () {
    return this.listName;
  };
  protoOf(Impression).na = function () {
    return this.products;
  };
  protoOf(Impression).pa = function () {
    return this.b9_1;
  };
  protoOf(Impression).qa = function () {
    return this.c9_1;
  };
  protoOf(Impression).w8 = function () {
    return this.d9_1;
  };
  protoOf(Impression).e1 = function () {
    return this.e9_1;
  };
  protoOf(Impression).hashCode = function () {
    return getStringHashCode(this.listName);
  };
  protoOf(Impression).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (other instanceof Impression) {
      tmp_3 = this.listName === other.listName;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = equals(this.products, other.products);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.owner == other.owner;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(this.data, other.data);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.globalData, other.globalData);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Impression).toString = function () {
    return "ECommerce.Impression(listName='" + this.listName + "', products=" + toString(this.products) + ", owner='" + this.owner + "', data=" + toString_0(this.data) + ', globalData=' + toString_0(this.globalData) + ')';
  };
  function Action_AddToCart_getInstance() {
    Action_initEntries();
    return Action_AddToCart_instance;
  }
  function Action_RemoveFromCart_getInstance() {
    Action_initEntries();
    return Action_RemoveFromCart_instance;
  }
  function Action_ViewDetail_getInstance() {
    Action_initEntries();
    return Action_ViewDetail_instance;
  }
  function ECommerce() {
  }
  var ECommerce_instance;
  function ECommerce_getInstance() {
    return ECommerce_instance;
  }
  function Event_0(name, type, owner, data, globalData) {
    type = type === VOID ? EventType_Other_getInstance() : type;
    owner = owner === VOID ? null : owner;
    data = data === VOID ? null : data;
    globalData = globalData === VOID ? null : globalData;
    this.j9_1 = name;
    this.type = type;
    this.k9_1 = owner;
    this.l9_1 = data;
    this.m9_1 = globalData;
  }
  protoOf(Event_0).e1 = function () {
    return this.j9_1;
  };
  protoOf(Event_0).sa = function () {
    return this.type;
  };
  protoOf(Event_0).pa = function () {
    return this.k9_1;
  };
  protoOf(Event_0).qa = function () {
    return this.l9_1;
  };
  protoOf(Event_0).w8 = function () {
    return this.m9_1;
  };
  protoOf(Event_0).hashCode = function () {
    return getStringHashCode(this.name);
  };
  protoOf(Event_0).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (other instanceof Event_0) {
      tmp_3 = this.name === other.name;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.type.equals(other.type);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.owner == other.owner;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(this.data, other.data);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.globalData, other.globalData);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Event_0).toString = function () {
    return "Event(name='" + this.name + "', type=" + this.type.toString() + ", owner='" + this.owner + "', data=" + toString_0(this.data) + ', globalData=' + toString_0(this.globalData) + ')';
  };
  var EventType_Navigation_instance;
  var EventType_Search_instance;
  var EventType_Other_instance;
  function values_0() {
    return [EventType_Navigation_getInstance(), EventType_Search_getInstance(), EventType_Other_getInstance()];
  }
  function valueOf_0(value) {
    switch (value) {
      case 'Navigation':
        return EventType_Navigation_getInstance();
      case 'Search':
        return EventType_Search_getInstance();
      case 'Other':
        return EventType_Other_getInstance();
      default:
        EventType_initEntries();
        THROW_IAE('No enum constant value.');
        break;
    }
  }
  var EventType_entriesInitialized;
  function EventType_initEntries() {
    if (EventType_entriesInitialized)
      return Unit_instance;
    EventType_entriesInitialized = true;
    EventType_Navigation_instance = new EventType('Navigation', 0);
    EventType_Search_instance = new EventType('Search', 1);
    EventType_Other_instance = new EventType('Other', 2);
  }
  function EventType(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function EventType_Navigation_getInstance() {
    EventType_initEntries();
    return EventType_Navigation_instance;
  }
  function EventType_Search_getInstance() {
    EventType_initEntries();
    return EventType_Search_instance;
  }
  function EventType_Other_getInstance() {
    EventType_initEntries();
    return EventType_Other_instance;
  }
  function Screen(name, owner, data, globalData) {
    owner = owner === VOID ? null : owner;
    data = data === VOID ? null : data;
    globalData = globalData === VOID ? null : globalData;
    this.va_1 = name;
    this.wa_1 = owner;
    this.xa_1 = data;
    this.ya_1 = globalData;
  }
  protoOf(Screen).e1 = function () {
    return this.va_1;
  };
  protoOf(Screen).pa = function () {
    return this.wa_1;
  };
  protoOf(Screen).qa = function () {
    return this.xa_1;
  };
  protoOf(Screen).w8 = function () {
    return this.ya_1;
  };
  protoOf(Screen).hashCode = function () {
    return getStringHashCode(this.name);
  };
  protoOf(Screen).equals = function (other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Screen) {
      tmp_2 = this.name === other.name;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.owner == other.owner;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = equals(this.data, other.data);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = equals(this.globalData, other.globalData);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(Screen).toString = function () {
    return "Screen(name='" + this.name + "', owner='" + this.owner + "', data=" + toString_0(this.data) + ', globalData=' + toString_0(this.globalData) + ')';
  };
  function Track() {
  }
  function get_PLATFORM() {
    return PLATFORM;
  }
  var PLATFORM;
  function get_nativePlatformValue(_this__u8e3s4) {
    return jsMap(_this__u8e3s4);
  }
  function get_nativePlatformValue_0(_this__u8e3s4) {
    return jsArray(_this__u8e3s4);
  }
  function threadSafeMutableMap() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    return LinkedHashMap_init_$Create$();
  }
  function get_timestamp(_this__u8e3s4) {
    return numberToDouble(_this__u8e3s4);
  }
  function get_currentTimeMillis() {
    return Date.now();
  }
  function AtomicRef(initialValue) {
    this.ea_1 = initialValue;
  }
  function atomicRef(value) {
    return new AtomicRef(value);
  }
  function newUUID() {
    return v4();
  }
  function get_commonPlatformValue(_this__u8e3s4) {
    var tmp0_safe_receiver = isArray(_this__u8e3s4) ? _this__u8e3s4 : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toList(tmp0_safe_receiver);
    return tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  }
  function get_commonPlatformValue_0(_this__u8e3s4) {
    return ktMap(_this__u8e3s4);
  }
  function jsMap(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.x();
    // Inline function 'kotlin.collections.fold' call
    var accumulator = {};
    var _iterator__ex2g4s = tmp0.c();
    while (_iterator__ex2g4s.d()) {
      var element = _iterator__ex2g4s.e();
      var acc = accumulator;
      // Inline function 'kotlin.collections.component1' call
      var key = element.q();
      // Inline function 'kotlin.collections.component2' call
      var value = element.r();
      acc[key] = value;
      accumulator = acc;
    }
    return accumulator;
  }
  function jsArray(_this__u8e3s4) {
    // Inline function 'kotlin.collections.fold' call
    var accumulator = [];
    var _iterator__ex2g4s = _this__u8e3s4.c();
    while (_iterator__ex2g4s.d()) {
      var element = _iterator__ex2g4s.e();
      var acc = accumulator;
      acc.push(element);
      accumulator = acc;
    }
    return accumulator;
  }
  function ktMap(obj) {
    var tmp;
    if (!(obj == null) ? isInterface(obj, KtMap) : false) {
      tmp = obj;
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.collections.associateWith' call
      var this_0 = Object.keys(obj);
      var result = LinkedHashMap_init_$Create$_0(coerceAtLeast(mapCapacity(this_0.length), 16));
      // Inline function 'kotlin.collections.associateWithTo' call
      var inductionVariable = 0;
      var last = this_0.length;
      while (inductionVariable < last) {
        var element = this_0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var tmp_0 = obj[element];
        var tmp$ret$1 = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
        result.y(element, tmp$ret$1);
      }
      tmp = result;
    }
    return tmp;
  }
  //region block: post-declaration
  protoOf(AnalyticsServiceImpl).trackWithoutContext = trackWithoutContext;
  protoOf(AnalyticsServiceImpl).identifyCurrentLocation = identifyCurrentLocation;
  protoOf(AnalyticsServiceImpl).identifyDeliveryLocation = identifyDeliveryLocation;
  protoOf(AnalyticsServiceImpl).identifyPerseusIds = identifyPerseusIds;
  defineProp(protoOf(AnalyticsServiceImpl), 'globalData', function () {
    return this.w8();
  });
  defineProp(protoOf(Action), 'name', protoOf(Action).e1);
  defineProp(protoOf(Action), 'ordinal', protoOf(Action).f1);
  defineProp(protoOf(Event), 'owner', function () {
    return this.pa();
  });
  defineProp(protoOf(Event), 'data', function () {
    return this.qa();
  });
  defineProp(protoOf(Event), 'globalData', function () {
    return this.w8();
  });
  defineProp(protoOf(Event), 'name', function () {
    return this.e1();
  });
  defineProp(protoOf(Impression), 'owner', function () {
    return this.pa();
  });
  defineProp(protoOf(Impression), 'data', function () {
    return this.qa();
  });
  defineProp(protoOf(Impression), 'globalData', function () {
    return this.w8();
  });
  defineProp(protoOf(Impression), 'name', function () {
    return this.e1();
  });
  defineProp(protoOf(Event_0), 'name', function () {
    return this.e1();
  });
  defineProp(protoOf(Event_0), 'owner', function () {
    return this.pa();
  });
  defineProp(protoOf(Event_0), 'data', function () {
    return this.qa();
  });
  defineProp(protoOf(Event_0), 'globalData', function () {
    return this.w8();
  });
  defineProp(protoOf(EventType), 'name', protoOf(EventType).e1);
  defineProp(protoOf(EventType), 'ordinal', protoOf(EventType).f1);
  defineProp(protoOf(Screen), 'name', function () {
    return this.e1();
  });
  defineProp(protoOf(Screen), 'owner', function () {
    return this.pa();
  });
  defineProp(protoOf(Screen), 'data', function () {
    return this.qa();
  });
  defineProp(protoOf(Screen), 'globalData', function () {
    return this.w8();
  });
  //endregion
  //region block: init
  AnalyticsServiceFactory_instance = new AnalyticsServiceFactory();
  ECommerce_instance = new ECommerce();
  PLATFORM = 'web';
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    defineProp($com$glovoapp$analytics, 'AnalyticsServiceFactory', AnalyticsServiceFactory_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$dynamicsession = $com$glovoapp$analytics.dynamicsession || ($com$glovoapp$analytics.dynamicsession = {});
    $com$glovoapp$analytics$dynamicsession.DynamicSession = DynamicSession;
    $com$glovoapp$analytics$dynamicsession.DynamicSession.create = create;
    defineProp($com$glovoapp$analytics$dynamicsession.DynamicSession, 'Companion', Companion_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$dynamicsession = $com$glovoapp$analytics.dynamicsession || ($com$glovoapp$analytics.dynamicsession = {});
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$dynamicsession = $com$glovoapp$analytics.dynamicsession || ($com$glovoapp$analytics.dynamicsession = {});
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    defineProp($com$glovoapp$analytics$events, 'ECommerce', ECommerce_getInstance);
    ECommerce.prototype.Action = Action;
    ECommerce.prototype.Action.values = values;
    ECommerce.prototype.Action.valueOf = valueOf;
    defineProp(ECommerce.prototype.Action, 'AddToCart', Action_AddToCart_getInstance);
    defineProp(ECommerce.prototype.Action, 'RemoveFromCart', Action_RemoveFromCart_getInstance);
    defineProp(ECommerce.prototype.Action, 'ViewDetail', Action_ViewDetail_getInstance);
    ECommerce.prototype.Product = Product;
    ECommerce.prototype.Event = Event;
    ECommerce.prototype.Impression = Impression;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Event = Event_0;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.EventType = EventType;
    $com$glovoapp$analytics$events.EventType.values = values_0;
    $com$glovoapp$analytics$events.EventType.valueOf = valueOf_0;
    defineProp($com$glovoapp$analytics$events.EventType, 'Navigation', EventType_Navigation_getInstance);
    defineProp($com$glovoapp$analytics$events.EventType, 'Search', EventType_Search_getInstance);
    defineProp($com$glovoapp$analytics$events.EventType, 'Other', EventType_Other_getInstance);
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    $com$glovoapp$analytics$events.Screen = Screen;
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    var $com$glovoapp$analytics$events = $com$glovoapp$analytics.events || ($com$glovoapp$analytics.events = {});
    var $com = _.com || (_.com = {});
    var $com$glovoapp = $com.glovoapp || ($com.glovoapp = {});
    var $com$glovoapp$analytics = $com$glovoapp.analytics || ($com$glovoapp.analytics = {});
    $com$glovoapp$analytics.jsMap = jsMap;
    $com$glovoapp$analytics.jsArray = jsArray;
    $com$glovoapp$analytics.ktMap = ktMap;
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = Event;
  _.$_$.b = Event_0;
  _.$_$.c = Screen;
  _.$_$.d = get_data;
  _.$_$.e = get_value;
  _.$_$.f = get_value_2;
  _.$_$.g = get_value_0;
  _.$_$.h = get_value_1;
  _.$_$.i = Action_AddToCart_getInstance;
  _.$_$.j = Action_RemoveFromCart_getInstance;
  _.$_$.k = EventType_Search_getInstance;
  //endregion
  return _;
}(module.exports, require('uuid'), require('./kotlin-kotlin-stdlib.js')));

//# sourceMappingURL=analytics-multiplatform-common-web.js.map
